import { v4 as uuidv4 } from 'uuid';
import { memo, useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { ElementsItem } from "./ElementsItem";
import { useWebGL } from '../../videoEdit.provider';
import { TimeLineContext } from "../timeline.config";
import { SERVER_STATUS } from '../../../../axios/ApiProvider';
import { GetElementsWidthLeft } from "../common/commonFunction";
import { SelectedItemID_Store, selectedGroupID_Store } from "../../../../store/actions/webgldata";
import { TimeCount_Store } from '../../../../store/actions/videoPlayAction';
import { useTheme } from '@mui/material';

export const ElementsContainer = (props) => {
  const { type, performanceMode } = props;
  const [timelineData, SetTimelineData] = useContext(TimeLineContext);
  const projectJSON = useSelector((store => store.projectdata.projectJSON));
  const videoElements = useSelector(store => store.webgldata.videoElements);
  const imageElements = useSelector(store => store.webgldata.imageElements);
  const thumbNails = useSelector(store => store.projectdata.thumbNails);
  const [gridOptions, setGridOptions] = useState({});
  const gridKeys = Object.keys(gridOptions);

  const [emptyGroupDrag, setEmptyGroupDrag] = useState(false);

  useEffect(() => {
    if (!projectJSON[type]) return;
    const tempOptions = Object.assign({}, projectJSON[type]);
    const tempKeys = Object.keys(tempOptions);

    tempKeys.sort((key1, key2) => (
      tempOptions[key1].sequence - tempOptions[key2].sequence
    ))

    let tempGridData = {};
    tempKeys.forEach(async (optionKey, index) => {
      // if (type === 'videos' && !videoElements[optionKey]) return;
      // if (type === 'images' && !imageElements[optionKey]) return;

      let tempOption = Object.assign({}, tempOptions[optionKey]);
      const [width, left] = await GetElementsWidthLeft(tempOption, timelineData.legendInfo);
      tempOption['id'] = optionKey;
      tempOption['style'] = { width: width, left: left };

      if (type === 'videos') {
        let thumbnails = [];
        let localThumbnails = [];
        const tempAssets = Object.assign({}, projectJSON.asset);
        const asset_uuid = tempOptions[optionKey]['asset_uuid'];

        let asset_info = tempAssets[asset_uuid];
        if (SERVER_STATUS !== 'localhost' && !!asset_info && !!asset_info.thumbnail) {
          if(tempAssets[asset_uuid].localThumbnail) {
            localThumbnails = Object.values(tempAssets[asset_uuid].localThumbnail)?.map(th => th.url)
          }
          thumbnails = tempAssets[asset_uuid].thumbnail;
        }
        else if (!!thumbNails[optionKey]) thumbnails = thumbNails[optionKey];

        let videoAssets = [];
        const thumbKeys = Object.keys(thumbnails);
        let thumbValues = Object.values(thumbnails);
        thumbValues.sort((a, b) => parseFloat(a.timestamp) - parseFloat(b.timestamp));
        // thumbKeys.forEach((thumbKey) => { videoAssets.push(thumbnails[thumbKey].signed_url); });
        thumbValues.forEach((thumbItem) => { videoAssets.push(thumbItem.signed_url); })
        tempOption['thumbnails'] = videoAssets;
        tempOption['localThumbnails'] = localThumbnails;
      }

      if (type === 'images') {
        let thumbnails = {};
        tempOption['thumbnails'] = [];
        const tempAssets = Object.assign({}, projectJSON.asset);
        const asset_uuid = tempOptions[optionKey]['asset_uuid'];

        if (SERVER_STATUS !== 'localhost' && !!asset_uuid && tempAssets[asset_uuid]) {
          thumbnails = tempAssets[asset_uuid];
        } else if (!!thumbNails[asset_uuid]) {
          thumbnails = thumbNails[asset_uuid][0];
        }

        if (!!thumbnails?.signed_url) {
          tempOption['thumbnails'] = [thumbnails.signed_url];
        }
      }


      if (!tempGridData[tempOption.groups]) tempGridData[tempOption.groups] = {};
      tempGridData[tempOption.groups][optionKey] = tempOption;
      if (index + 1 === tempKeys.length) {
        setGridOptions(tempGridData);
      }
    })


    if (!Object.keys(tempGridData).length) setGridOptions({});
  }, [timelineData.legendInfo, projectJSON, videoElements, imageElements]);

  const onDrop = (e) => {
    const existingBox = document.querySelector('.drag-overlay');
    if (existingBox) existingBox.remove();
    const activeItem = document.querySelector('.active-item');
    if (activeItem) activeItem.parentNode.style.opacity = 1;

    setEmptyGroupDrag(false);
    const target = e.currentTarget;
    target.style.borderTop = ""
    target.style.height = "3px"
    const dragingGroups = timelineData.dragingGroups;
    if (!dragingGroups || !gridOptions[dragingGroups.id]) return;
    if (dragingGroups.type !== type) return;
    const groupInfo = Object.keys(gridOptions[dragingGroups.id]);
    if (groupInfo.length <= 1) return;

    const newUUID = uuidv4();
    let nextUUID = target.getAttribute('next-uuid');
    if (dragingGroups.type === type) {
      SetTimelineData({ ...timelineData, dropedGroup: { id: newUUID, beforeID: nextUUID } });
    }
    if (dragClone) {
      dragClone.remove();
      dragClone = null;
    }
  }

  let dragClone = null;

  function copyBackgroundStyles(source, target) {
    const computed = window.getComputedStyle(source);
    const bgProps = [
      'background',
      'background-color',
      'background-image',
      'background-position',
      'background-size',
      'background-repeat',
      'background-attachment',
      'background-origin',
      'background-clip'
    ];

    for (let prop of bgProps) {
      target.style[prop] = computed.getPropertyValue(prop);
    }

    // Recursively apply to children (optional; include if you want full fidelity)
    Array.from(source.children).forEach((child, index) => {
      copyBackgroundStyles(child, target.children[index]);
    });
  }

  const onDragOver = (e) => {
    //console.log("onDragOver")
    setEmptyGroupDrag(true);

    const draggingGroups = timelineData.dragingGroups;

    if (!draggingGroups || !gridOptions[draggingGroups.id]) return;
    if (draggingGroups.type !== type) return;

    const groupInfo = Object.keys(gridOptions[draggingGroups.id]);
    if (groupInfo.length <= 1) return;

    e.preventDefault();
    if (e.dataTransfer) {
      e.dataTransfer.effectAllowed = 'all';
      e.dataTransfer.dropEffect = 'move';
    }

    const target = e.currentTarget;
    target.style.position = 'relative';
    target.style.height = '60px';

    const activeItem = document.querySelector('.active-item');
    if (!activeItem) return;

    if (activeItem.parentNode) {
      activeItem.parentNode.style.opacity = 0;
    }

    const rect = activeItem.getBoundingClientRect();
    const containerRect = target.getBoundingClientRect();
    const offsetLeft = rect.left - containerRect.left;

    if (!dragClone) {
      const existingClones = document.querySelectorAll('.drag-overlay');
      existingClones.forEach(clone => clone.remove());
      dragClone = activeItem.cloneNode(true);
      copyBackgroundStyles(activeItem, dragClone);

      if (activeItem.children[0] && activeItem.children[0].classList.contains('inner-text-value')) {
        dragClone.style.display = 'flex';
        dragClone.style.justifyContent = 'center';
        dragClone.style.alignItems = 'center';
        dragClone.style.overflow = 'hidden';
        dragClone.style.backgroundColor = 'rgba(248, 113, 113, 0.5)';
      }

      dragClone.classList.remove('active-item');
      dragClone.classList.add('drag-overlay');
      dragClone.style.opacity = '0.8';
      dragClone.style.position = 'absolute';
      dragClone.style.top = '0';
      dragClone.style.zIndex = '11';
      dragClone.style.pointerEvents = 'none';
      dragClone.style.border = '1px dashed #0098FD';
      target.appendChild(dragClone);
    }

    dragClone.style.left = `${offsetLeft}px`;
    dragClone.style.width = `${rect.width}px`;
    dragClone.style.height = `${rect.height}px`;
  };

  const onDragLeave = (e) => {
    const existingBox = document.querySelector('.drag-overlay');
    if (existingBox) existingBox.remove();
    const activeItem = document.querySelector('.active-item');
    if (activeItem) activeItem.parentNode.style.opacity = 1;

    setEmptyGroupDrag(false);
    const dragingGroups = timelineData.dragingGroups;
    if (!dragingGroups || !gridOptions[dragingGroups.id]) return;
    if (dragingGroups.type !== type) return;
    const groupInfo = Object.keys(gridOptions[dragingGroups.id]);
    if (groupInfo.length <= 1) return;

    const target = e.currentTarget;
    target.style.height = "3px"
    target.style.borderTop = ""
    if (dragClone) {
      dragClone.remove();
      dragClone = null;
    }
  };

  return (
    gridKeys.map((gridKey, key) =>
      <div
        className="Elements-groups-wrapper"
        key={key}
        group-id={gridKey}
      >
        <ElementsGroup
          gridOptions={gridOptions}
          groupOptions={gridOptions[gridKey]}
          groupID={gridKey}
          type={type}
          performanceMode={performanceMode}
        />
        <div
          className="empty-group-cotainer"
          next-uuid={gridKey}
          style={{ height: '3px' }}
          onDrop={onDrop}
          onDragOver={onDragOver}
          onDragLeave={onDragLeave}
          onTouchStart={() => { }}
          onTouchMove={onDragOver}
          onTouchEnd={onDrop}
        />
      </div>
    )
  )
}

export const ElementsGroup = memo((props) => {
  const elementsGroupConainer = useRef();
  const { gridOptions, groupOptions, groupID, type, performanceMode } = props;
  const groupKeys = Object.keys(groupOptions);
  const projectJSON = useSelector((store => store.projectdata.projectJSON));
  const dispatch = useDispatch();
  const [webGLContext, setWebGLContext] = useWebGL();
  const [timelineData, SetTimelineData] = useContext(TimeLineContext);
  const selectedID = useSelector(store => store.webgldata.selectedItemID);
  const selectedGroupID = useSelector(store => store.webgldata.selectedGroupID);
  const activeGroup = selectedGroupID === groupID
  const Time_Count = useSelector((store) => store.videodata.Time_Count);

  const [isShiftKey, setIsShiftKey] = useState(false);
  const theme = useTheme();

  const isKeyboardDown = (e) => {
    if(!isShiftKey && e.code == 'ShiftLeft'){
      setIsShiftKey(true);
    }
  }

  const isKeyboardUp = (e) => {
    if(isShiftKey && e.code == 'ShiftLeft'){
      setIsShiftKey(false);
    }
  }
  useEffect(() => {
    window.addEventListener('keydown', isKeyboardDown, false);
    window.addEventListener('keyup', isKeyboardUp, false);
    return () => {
    window.removeEventListener("keydown", isKeyboardDown)
    window.removeEventListener('keyup', isKeyboardUp);
    }
  }, [isShiftKey])

  const onClickItem = (id, event = {}) => {
    const currentSelection = Array.isArray(selectedID)
      ? selectedID.filter(Boolean)
      : selectedID ? [selectedID] : [];
    const additive = event.shiftKey || event.ctrlKey || event.metaKey || isShiftKey;
    const isContextClick = event.type === 'contextmenu';

    if (isContextClick && currentSelection.includes(id)) {
      // Keep the entire selection when opening bulk actions.
    } else if (additive) {
      const nextSelection = currentSelection.includes(id)
        ? currentSelection.filter((itemId) => itemId !== id)
        : [...currentSelection, id];
      dispatch(SelectedItemID_Store(
        nextSelection.length === 0 ? null : nextSelection.length === 1 ? nextSelection[0] : nextSelection
      ));
    } else {
      dispatch(SelectedItemID_Store(id));
    }
    const selectedGElement = groupOptions[id];
    let indicatorT = Time_Count.getTime();
    let nextTime = 0;
    let endTime = selectedGElement?.timeline_end;
    let startTime = selectedGElement?.timeline_start;
    if(indicatorT < endTime && indicatorT > startTime){
    }else{
      if (indicatorT > endTime) nextTime = endTime - 1;
      else if (indicatorT < startTime) nextTime = startTime+1;
      const newTimeData = new Date(nextTime);
      dispatch(TimeCount_Store(newTimeData))
    }

    if (!webGLContext.tsManual.state) return;
    let temptsManual = { type: "", state: false, tsID: "", clashID: "", flag: "" };
    setWebGLContext({ ...webGLContext, tsManual: temptsManual });
  }

  const onTouchStart = (e) => {
    onDragStart(e);
  }

  const onTouchMove = (e) => {
    onDragOver(e);
  };

  const onTouchEnd = (e) => {
    onDrop(e);
  };

  const onDragStart = (e) => {
    const img = new Image();
    img.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="1" height="1"></svg>';
    if (e.dataTransfer) e.dataTransfer.setDragImage(img, 0, 0);
  }

  const onDragLeave = (e) => {
    isMobile = false;
    mobileEmptyTrack = null;
    const activeItem = document.querySelector('.active-item');
    if (activeItem) activeItem.parentNode.style.opacity = 1;
  }

  const dragCloneRef = useRef(null);
  let isMobile = false;
  let mobileEmptyTrack = null;

  const onDragOver = (e) => {
    const activeItem = document.querySelector('.active-item');
    const draggingGroups = timelineData.dragingGroups;

    if (e._reactName === "onTouchMove" && e.type === "touchmove") {
      const touch = e.changedTouches[0];
      if (!touch) return;
      isMobile = true;
      let isInside;
      const x = touch.clientX;
      const y = touch.clientY;
      const elementUnderTouch = document.elementFromPoint(x, y);
      // if (elementUnderTouch && elementUnderTouch.classList.contains((`${type}-group-wrapper`))) {
      //   console.log(elementUnderTouch)
      // }
  
      // const nextEmptyContainer = e.target.parentNode.parentNode.parentNode.nextSibling;
      let mobileGroupTrack;
      if (elementUnderTouch && elementUnderTouch.classList.contains((`${type}-group-wrapper`))) {
        mobileGroupTrack = elementUnderTouch;
      } else {
      if(activeItem) activeItem.parentNode.style.opacity = 1;
      }

      if (!mobileGroupTrack) return;
      const rect = mobileGroupTrack.getBoundingClientRect();
      isInside =
      x >= rect.left &&
      x <= rect.right &&
      y >= rect.top &&
      y <= rect.bottom;

      if (isInside && elementUnderTouch && elementUnderTouch.classList.contains((`${type}-group-wrapper`))) {
        mobileEmptyTrack = elementUnderTouch;
        if (activeItem) activeItem.parentNode.style.opacity = 0;
        // console.log("Inside")
      }

    } else {
      isMobile = false;
    }

    if (!draggingGroups || draggingGroups.id === groupID && !isMobile) return;
    if (draggingGroups.type !== type) return;

    if (e.dataTransfer) {
      e.dataTransfer.effectAllowed = 'all';
      e.dataTransfer.dropEffect = 'move';
    }

    const target = mobileEmptyTrack || e.currentTarget;
    target.style.position = 'relative';

    // if (type === 'videos') {
    //   target.style.height = '60px';
    // } else {
    //   target.style.height = '40px';
    // }

    if (!activeItem) return;

      if(!isMobile) activeItem.parentNode.style.opacity = 0;
    // --- DRAGGED ITEM CLONE ---
    if (!dragCloneRef.current) {
      //Item Cloning Start
      dragCloneRef.current = activeItem.cloneNode(true);

      if (activeItem.children[0] && activeItem.children[0].classList.contains('inner-text-value')) {
        dragCloneRef.current.style.display = 'flex';
        dragCloneRef.current.style.justifyContent = 'center';
        dragCloneRef.current.style.alignItems = 'center';
        dragCloneRef.current.style.backgroundColor = 'rgba(248, 113, 113, 0.5)';
        dragCloneRef.current.style.overflow = 'hidden';
      }

      dragCloneRef.current.classList.remove('active-item');
      dragCloneRef.current.classList.add('drag-overlay');
      dragCloneRef.current.style.opacity = '0.5';
      dragCloneRef.current.style.position = 'absolute';
      dragCloneRef.current.style.top = '0';
      dragCloneRef.current.style.zIndex = '11';
      dragCloneRef.current.style.pointerEvents = 'none';
      dragCloneRef.current.style.border = '1px dashed #0098FD';
      if(!isMobile || mobileEmptyTrack && isMobile) target.appendChild(dragCloneRef.current);
    }

    const rect = activeItem.getBoundingClientRect();
    const containerRect = target.getBoundingClientRect();
    const offsetLeft = rect.left - containerRect.left;

    dragCloneRef.current = document.querySelector('.drag-overlay');

    if (!dragCloneRef.current) return;
    dragCloneRef.current.style.left = `${offsetLeft}px`;
    dragCloneRef.current.style.width = `${rect.width}px`;
    dragCloneRef.current.style.height = `${rect.height}px`;
    //Item Cloning End
  };


  const onDrop = (e) => {
    isMobile = false;
    dragCloneRef.current = null;
    const dragingGroups = timelineData.dragingGroups;
    let groupInfo;

    const activeItem = document.querySelector('.active-item');
    if (activeItem) activeItem.parentNode.style.opacity = 1;
    if (mobileEmptyTrack) {
      if (dragingGroups) groupInfo = Object.keys(gridOptions[dragingGroups.id]);
      if (groupInfo && groupInfo.length <= 1) return;
      const newUUID = uuidv4();
      let nextUUID = mobileEmptyTrack.getAttribute('next-uuid');
      if (dragingGroups && type && dragingGroups.type === type) {
        SetTimelineData({ ...timelineData, dropedGroup: { id: newUUID, beforeID: nextUUID } });
      }
      mobileEmptyTrack = null;
      return;
    }
    
    if (!dragingGroups || dragingGroups.id === groupID) return;
    if (dragingGroups.type !== type) return;
    if (dragingGroups.type === type) {
      SetTimelineData({
        ...timelineData,
        dropedGroup: {
          id: groupID,
          beforeID: groupID
        }
      });
    }
    
    mobileEmptyTrack = null;
  }

  const onClickGroup = (e) => {
    if (groupID !== selectedGroupID) {
      dispatch(selectedGroupID_Store(groupID))
    }

  }
  const checkSelectedItem = (id) => {
    let isSelectedItem = false;
    if (Array.isArray(selectedID)) {
      isSelectedItem = selectedID.includes(id);
    } else {
      isSelectedItem = (selectedID === id);
    }
    return isSelectedItem;
  }

  return (
    <div
      ref={elementsGroupConainer}
      onDrop={onDrop}
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
      className={`Element-group-container ${type}-group-wrapper ${activeGroup ? 'bg-bgActive/30' : 'hover:bg-bgActive/5'} ${theme.palette.mode === 'dark' ? 'dark' : 'light'}`}
      onClick={(e) => { onClickGroup(e) }}
      onContextMenu={(e) => { onClickGroup(e) }}
    >
      {groupKeys.map((groupKey, key) =>
        <ElementsItem key={groupOptions[groupKey].id} type={type}
          gridOptions={gridOptions}
          groupData={groupOptions}
          ElementsOb={groupOptions[groupKey]}
          selected={checkSelectedItem(groupOptions[groupKey].id)}
          ClickEven={onClickItem}
          setShiftKey={setIsShiftKey}
          performanceMode={performanceMode}
        />
      )}

    </div>
  )
})
